<template>
  <!-- <div class="express-dialgo" v-if="isShow"> -->
  <el-dialog :close-on-click-modal="false" title="快递追踪" :visible.sync="isShow" width="40%">
    <!-- <div class="order-cn">
      <p>快递追踪</p>
      <i class="el-icon-circle-close" @click="hide"></i> -->
    <p>
      <span>物流单号：{{ LogisticCode }}</span>
      <span style="margin-left: 80px;">物流快递： <span v-if="ShipperCode === 'ZTO'">中通快递</span>
        <span v-if="ShipperCode === 'STO'">申通快递</span>
        <span v-if="ShipperCode === 'YTO'">圆通速递</span>
        <span v-if="ShipperCode === 'YD'">韵达速递</span>
        <span v-if="ShipperCode === 'YZPY'">邮政快递包裹</span>
        <span v-if="ShipperCode === 'EMS'">EMS</span>
        <span v-if="ShipperCode === 'JD'">京东快递</span>
        <span v-if="ShipperCode === 'SF'">顺丰速运</span>
        <span v-if="ShipperCode === 'DBL'">德邦快递</span>
      </span>
    </p>
    <!-- <el-table :data="traces">
      <el-table-column label="当前状态" prop="AcceptStation"></el-table-column>
      <el-table-column label="更新时间" prop="AcceptTime"></el-table-column>
    </el-table> -->
    <div style="height: 300px;overflow:auto;">
      <el-steps direction="vertical" :active="1">
        <el-step v-for="(item, index) in traces" :description="item.AcceptStation + item.AcceptTime" :key="index" :status="index === 0 ? 'finish' : 'process'"></el-step>
      </el-steps>
    </div>
    <!-- </div> -->
  </el-dialog>
  <!-- </div> -->
</template>
<script>
import { getExpressDetail } from '@/api/oms'
export default {
  name: 'express-dialog',
  data () {
    return {
      isShow: false,
      express: {},
      traces: [],
      ShipperCode: '',
      LogisticCode: ''
    }
  },
  methods: {
    show (express, phone) {
      this.isShow = true
      this.express = express
      let val = phone ? this.$msg.filterBridal(phone).substr(-4) : ''
      this.getExpressDetail(val)
    },
    hide () {
      this.isShow = false
    },
    getExpressDetail (val) {
      console.log('val', val)
      getExpressDetail(this.express, val).then(res => {
        console.log('reesssss', res)
        let expressInfo = res.data.data
        this.traces = expressInfo.Traces.sort((a, b) => Date.parse(b.AcceptTime) - Date.parse(a.AcceptTime))
        this.ShipperCode = expressInfo.ShipperCode
        this.LogisticCode = expressInfo.LogisticCode
        // this.expressInfo = {
        //   StateEx: '2',
        //   LogisticCode: '3103630045838',
        //   ShipperCode: 'YD',
        //   Traces: [
        //     {
        //       Actio: '1',
        //       AcceptStation: '【深圳市】广东深圳公司中心分拨分部 已揽收',
        //       AcceptTime: '2020-06-17 03:31:04',
        //       Location: '深圳市'
        //     },
        //     {
        //       Action: '2',
        //       AcceptStation: '【深圳市】已离开 广东深圳公司中心分拨分部；发往 上海分拨中心',
        //       AcceptTime: '2020-06-17 03:34:08',
        //       Location: '深圳市'
        //     },
        //     {
        //       Action: '2',
        //       AcceptStation: '【深圳市】广东深圳公司 已揽收',
        //       AcceptTime: '2020-06-17 03:37:46',
        //       Location: '深圳市'
        //     },
        //     {
        //       Action: '2',
        //       AcceptStation: '【深圳市】已到达 广东深圳公司',
        //       AcceptTime: '2020-06-17 08:02:33',
        //       Location: '深圳市'
        //     },
        //     {
        //       Action: '2',
        //       AcceptStation: '【深圳市】已离开 广东深圳公司；发往 上海分拨中心',
        //       AcceptTime: '2020-06-17 08:11:33',
        //       Location: '深圳市'
        //     },
        //     {
        //       Action: '2',
        //       AcceptStation: '【深圳市】广东深圳公司福田区水围站分部 已揽收',
        //       AcceptTime: '2020-06-17 09:22:25',
        //       Location: '深圳市'
        //     }
        //   ],
        //   State: '2',
        //   EBusinessID: '1470400',
        //   Success: true,
        //   Location: '深圳市'
        // }
        // this.traces = this.expressInfo.Traces.sort((a, b) => Date.parse(b.AcceptTime) - Date.parse(a.AcceptTime))
        // this.ShipperCode = this.expressInfo.ShipperCode
        // this.LogisticCode = this.expressInfo.LogisticCode
      })
    }
  }
}
</script>
<style scoped lang="less">
// .express-dialgo {
//   position: fixed;
//   width: 100%;
//   top: 20%;
// .order-cn {
//   background: #fff;
//   box-shadow: 0 3px 12px rgba(0, 0, 0, .34);
//   width: 713px;
//   height: auto;
//   border-radius: 8px;
//   margin: 0 auto;
//   padding: 22px 60px;
//   box-sizing: border-box;
i {
  float: right;
  font-size: 28px;
  overflow: hidden;
  height: 28px;
  cursor: pointer;
  color: #2a2a2a;
}

h3 {
  font-size: 24px;
  line-height: 40px;
  padding: 20px 0;
  color: #2a2a2a;
  margin-top: 15px;
  border-bottom: 1px solid #e8e8e8;
  font-weight: normal;
}

p {
  font-size: 18px;
  color: #2a2a2a;
  line-height: 30px;
  padding: 10px 0;
}

button {
  width: 110px;
  height: 46px;
  border-radius: 30px;
  color: #fff;
  font-size: 18px;
  background: #2a2a2a;
  outline: none;
  border: none;
  box-shadow: none;
  float: right;
  margin-top: 150px;
  cursor: pointer;
  margin-left: 15px;

  &:hover {
    opacity: 0.6;
  }
}

table {
  text-align: center;
  font-size: 16px;
  color: #1d1e1d;
  border-color: #e8e8e8;
  margin-top: 8px;
  max-height: 300px;

  tr {
    th {
      line-height: 50px;
      background: #f2f2f2;
      font-weight: normal;
    }

    td {
      line-height: 80px;
      color: #1d1e1d;
      font-weight: 100;
    }
  }
}

// }
// }
</style>
